export const apiUrl = process.env.REACT_APP_API_URL;

export const endpoints = {
    availabilities: `${apiUrl}availabilities`,
    reservations: `${apiUrl}reservations`
};